export var GridStateType;
(function (GridStateType) {
    GridStateType["columns"] = "columns";
    GridStateType["filter"] = "filter";
    GridStateType["pagination"] = "pagination";
    GridStateType["pinning"] = "pinning";
    GridStateType["rowSelection"] = "rowSelection";
    GridStateType["sorter"] = "sorter";
    GridStateType["treeData"] = "treeData";
})(GridStateType || (GridStateType = {}));
